<template>
    <tg-layout>
        <template slot="header">
            <tg-search-tool
                @on-submit="handleSearch"
            >
                <el-row type="flex">
                    <template >
                        <tg-radio-button
                            :items="dateOptions"
                            @on-click="handleDateChange"
                            v-model="selectedDateOption"
                        ></tg-radio-button>
                    </template>
                
                    <template>
                        <el-input
                            v-if="$user.group > 20"
                            :placeholder="$t('column.l20_account')"
                            v-model="searchData.targetName"
                            class="tg-input border-none input-search-username"
                            size="small"
                            clearable
                        ></el-input>
                        <tg-dropdown
                            :items="dropdown"
                            @on-change="handleSearchTypeChange"
                            trigger="click"
                        ></tg-dropdown>
                        <el-input
                            :placeholder="$t('component.form.input.placeholder.game_data')"
                            v-model="searchData.searchKey"
                            class="tg-input border-none input-search-username"
                            size="small"
                            clearable
                        ></el-input>
                    </template>
                </el-row>
            </tg-search-tool>
        </template>

        <tg-table
            ref="table"
            :columns="columns"
            :proxy="proxy"
            align="center"
            :fit="true"
            >
            <template slot="ID" slot-scope="scope">
                <span class="as-link" @click="handleClick(scope.column, scope.row, 0)">{{
                scope.value
                }}</span>
            </template>

            <template slot="competitionName" slot-scope="scope">
                <span>{{ scope.value }}</span><br>
                <span style="font-size:12px; color:#888888;">{{ scope.row.competitionNameEn }} </span>
            </template>

            <template slot="eventName" slot-scope="scope">
                <span>{{ scope.value }}</span><br>
                <span style="font-size:12px; color:#888888;">{{ scope.row.eventNameEn }} </span>
            </template>

            <template slot="competitionLanguage" slot-scope="scope">
                <tg-button @click.native="handleClick(scope.column, scope.row, 1)" style="width:75%; font-size:18px; color: #fff; background-color: #7367f0;">{{ $t("component.label.competition") /* 联盟 */ }}</tg-button>
                <!-- <tg-button style="width:75%; font-size:18px; color: #fff;background-color: #7367f0;" @click.native="handleClick(scope.column, scope.row, 1)">{{ $t("component.label.competition") /* 联盟 */ }}</tg-button> -->
            </template>

            <template slot="homeTeamLanguage" slot-scope="scope">
                <tg-button @click.native="handleClick(scope.column, scope.row, 2)" style="width:75%; font-size:18px; color: #fff; background-color: #ea5455;">{{ $t("component.label.homeTeam") /* 主队 */ }}</tg-button>
            </template>

            <template slot="awayTeamLanguage" slot-scope="scope">
                <tg-button @click.native="handleClick(scope.column, scope.row, 3)" style="width:75%; font-size:18px; color: #fff; background-color: #ff9f43;">{{ $t("component.label.awayTeam") /* 客队 */ }}</tg-button>
            </template>
        </tg-table>

        <tg-dialog
            ref="detail"
            :show-close="true"
            theme="info"
            :showIcon="false"
            width="70%"
            :title="detail.title"
            :visible.sync="detail.visible"
            destroy-on-close
            :showFooter="false"
            append-to-body
        >
            <tg-form-table
                :columns="detailColumns"
                :data.sync="detailData"
                :fenceRow="2"
                :fenceCol="2"
                :columnWidth="250"
                :cellWidth="400"
            >

                <template slot="language" slot-scope="scope">
                    <span >{{ scope.row[scope.column.name].competitionName }}</span><br>
                    <span style="font-size:12px; color:#888888;">{{ scope.row[scope.column.name].eventName }} </span>
                </template>
            </tg-form-table>
        </tg-dialog>

        <tg-dialog
            ref="competition"
            :show-close="true"
            theme="info"
            :showIcon="false"
            width="70%"
            :title="competition.title"
            :visible.sync="competition.visible"
            destroy-on-close
            :showFooter="true"
            append-to-body
            custom-class="tg-confirm-dialog"
            @on-confirm="handleUpdateCompetition()"
            :confirmLabel="$t('component.btn.save')"
        >
            <template>
                <div style="width: 100%; margin-bottom: 10px;">
                    <span style="float: left;"> {{ $t("column.competitionName") }}</span><br>
                    <el-input
                        v-model="competition.name"
                        disabled
                    ></el-input><br>
                </div> 
            </template>

            <tg-form-table
                :columns="competitionColumns"
                :data.sync="competitionData"
                :fenceRow="2"
                :fenceCol="2"
                :columnWidth="250"
                :cellWidth="400"
            >

                <template slot="language" slot-scope="scope">
                    <el-input
                        v-if="!isSub && scope.column.enable == true"
                        v-model="competitionData[scope.column.name].name"
                        class="tg-input col-8"
                        clearable
                    ></el-input>
                    <span v-else>
                        <span >{{ scope.row[scope.column.name].name }}</span>
                    </span>
                </template>
            </tg-form-table>
        </tg-dialog>

        <tg-dialog
            ref="team"
            :show-close="true"
            theme="info"
            :showIcon="false"
            width="70%"
            :title="team.title"
            :visible.sync="team.visible"
            destroy-on-close
            :showFooter="true"
            append-to-body
            custom-class="tg-confirm-dialog"
            @on-confirm="handleUpdateTeam(teamData)"
            :confirmLabel="$t('component.btn.save')"
        >
            <template>
                <div style="width: 100%; margin-bottom: 10px;">
                    <span style="float: left;"> {{ $t("component.label.teamName") }}</span><br>
                    <el-input
                        v-model="team.name"
                        disabled
                    ></el-input><br>
                </div> 
            </template>

            <tg-form-table
                :columns="teamColumns"
                :data.sync="teamData"
                :fenceRow="2"
                :fenceCol="2"
                :columnWidth="250"
                :cellWidth="400"
            >

                <template slot="language" slot-scope="scope">
                    <el-input
                        v-if="!isSub && scope.column.enable == true"
                        v-model="teamData[scope.column.name].name"
                        class="tg-input col-8"
                        clearable
                    ></el-input>
                    <span v-else>
                        <span >{{ scope.row[scope.column.name].name }}</span>
                    </span>
                </template>
            </tg-form-table>
        </tg-dialog>

    </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgSearchTool from "@/components/tool/TgSearchTool";
import TgTable from "@/components/table/TgTable";
import TgButton from "@/components/button/TgButton";
import TgDialog from "@/components/dialog/TgDialog";
import TgFormTable from "@/components/table/TgFormTable";
import TgDropdown from "@/components/dropdown/TgDropdown";
import TgRadioButton from "@/components/button/TgRadioButton.vue";

import apis from "@/apis";
const api = apis.game.language;

export default {
    components: {
        TgLayout,
        TgSearchTool,
        TgTable,
        TgButton,
        TgDialog,
        TgFormTable,
        TgDropdown,
        TgRadioButton,
    },
    data() {
        return {
            columns: [],
            detailColumns: [],
            competitionColumns:[],
            teamColumns:[],
            dateOptions: [
                {
                    'langKey': "component.date.picker.today",
                    'value': 0,
                },
                {
                    'langKey': "component.date.picker.tomorrow",
                    'value': 1,
                },
                {
                    'langKey': "component.date.picker.the_day_after_tomorrow",
                    'value': 2,
                },
                {
                    'langKey': "component.date.picker.big_day_after_tomorrow",
                    'value': 3,
                },

            ],
            dropdown: [
                {
                    'label': this.$t("component.dropdown.game.language[0]"),
                    'value': 1,
                },
                {
                    'label': this.$t("component.dropdown.game.language[1]"),
                    'value': 2,
                },
            ],
            proxy: api.getData,
            searchData: {
                dateType: 0,
                targetName:"",
                searchType:1,
                searchKey: "",
            },
            selectedDateOption:0,
            fenceRow: 3,
            fenceCol: 2,
            detailData: {},
            detail: {
                title: "",
                visible: false,
            },
            competitionData: {},
            competition: {
                title: "",
                name:"",
                visible: false,
            },
            teamData: {},
            team: {
                title: "",
                name: "",
                visible: false,
            },
        };
    },
    computed: {
        request() {
            return this.searchData
        },
    },
    created() {
        api.getColumns().then((response) => {
            this.columns = response.data.list;
            this.detailColumns = response.data.detail;
            this.competitionColumns = response.data.competition;
            this.teamColumns = response.data.team;
            this.$refs.table.init();
        });
    },
    methods: {
        handleSearch() {
            if(this.$user.group == 20){
                this.searchData.targetName = this.$user.username;
            }
            this.$refs.table.search(this.request);
        },
        handleSearchTypeChange(item) {
            this.searchData.searchType = item.value;
        },
        handleDateChange(item) {
            this.searchData.dateType = item;
        },
        handleClick(column, row, type) {
            this.$store.commit('TOGGLE_FULL_SCREEN_LOADING', true);
            switch (type) {
                // 詳細資料
                case 0:
                    api.getDetail({targetName:this.searchData.targetName,gameId:row.eventId}).then((response) => {
                        this.detailData = response.data;
                        this.detail.title = "ID - " + row.eventId;
                        this.$store.commit('TOGGLE_FULL_SCREEN_LOADING', false);
                        this.detail.visible = true;
                    });
                    break;

                // 聯盟多國語
                case 1:
                    api.getCompetition({targetName:this.searchData.targetName, competitionId:row.competitionId }).then((response) => {
                        this.competitionData = response.data.lang;
                        this.competition.title = this.$t("component.label.competition") + " - " + row.competitionName;
                        this.competition.name = row.competitionName;
                        this.competitionData.competitionId = row.competitionId;
                        this.$store.commit('TOGGLE_FULL_SCREEN_LOADING', false);
                        this.competition.visible = true;
                    });
                    break;

                // 主隊
                case 2:
                    api.getTeam({targetName:this.searchData.targetName, teamId: row.homeTeamId }).then((response) => {
                        this.teamData = response.data.lang;
                        this.team.title = this.$t("component.label.homeTeam") + " - " + row.eventName;
                        this.team.name = this.teamData['zh-cn'].name;
                        this.teamData.teamId = row.homeTeamId;
                        this.$store.commit('TOGGLE_FULL_SCREEN_LOADING', false);
                        this.team.visible = true;
                    });
                    break;

                // 客隊
                case 3:
                    api.getTeam({targetName:this.searchData.targetName, teamId: row.awayTeamId }).then((response) => {
                        this.teamData = response.data.lang;
                        this.team.title = this.$t("component.label.awayTeam") + " - " + row.eventName;
                        this.team.name = this.teamData['zh-cn'].name;
                        this.teamData.teamId = row.awayTeamId;
                        this.$store.commit('TOGGLE_FULL_SCREEN_LOADING', false);
                        this.team.visible = true;
                    });
                    break;
            
                default:
                    break;
            }
            
        },

        handleUpdateCompetition() {
            let data = { ...this.competitionData };
            let competitionId = data.competitionId;

            Object.keys(data).forEach(element => {
                data[element] = data[element].name;
            });

            this.$store.commit('TOGGLE_FULL_SCREEN_LOADING', true);
            api.updateCompetition({...data,targetName:this.searchData.targetName,competitionId:competitionId}).then((response) => {
                this.$store.commit('TOGGLE_FULL_SCREEN_LOADING', false);
                
                if (response.retcode == 0) {
                    this.$message.success(this.$t("message.success.update"));
                    this.team.visible = false;
                } else {
                    this.$message.error(this.$t("statusCode[" + response.retcode + "]"));
                }
            });
        },

        handleUpdateTeam() {
            let data = { ...this.teamData };
            let teamId = data.teamId;

            Object.keys(data).forEach(element => {
                data[element] = data[element].name;
            });

            this.$store.commit('TOGGLE_FULL_SCREEN_LOADING', true);
            api.updateTeam({ ...data,targetName:this.searchData.targetName, teamId: teamId }).then((response) => {
                this.$store.commit('TOGGLE_FULL_SCREEN_LOADING', false);

                if (response.retcode == 0) {
                    this.$message.success(this.$t("message.success.update"));
                    this.team.visible = false;
                } else {
                    this.$message.error(this.$t("statusCode[" + response.retcode + "]"));
                }
            });
        },
  },
};
</script>
